    @if (user && visible) {
      <nav #nav class="cnt-print-hide md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-dark-text/8 shadow-[0_-4px_16px_rgba(0,0,0,0.04)]"
        style="padding-bottom: env(safe-area-inset-bottom, 0);">
        <!-- Mode label: a small pill straddling the top border that names the
             slot set below (Hosting vs Traveling) instead of leaving it implied.
             Absolutely positioned, so the bar's height and the page's pb-16
             clearance don't change. -->
        <span
          class="absolute -top-2.5 left-1/2 -translate-x-1/2 px-2 py-1 rounded-full bg-white border border-dark-text/10 shadow-sm text-[0.55rem] uppercase tracking-[0.14em] font-button font-bold leading-none whitespace-nowrap"
          [class.text-jungle-green]="view === 'host'"
          [class.text-muted-text]="view !== 'host'"
        >
          <span class="sr-only">Current mode: </span>{{ view === 'host' ? 'Hosting' : 'Traveling' }}
        </span>
        <ul class="grid grid-cols-5">
          @for (slot of slots; track slot.label) {
            <li class="min-w-0">
              <a [routerLink]="slot.routerLink" [fragment]="slot.fragment || undefined"
                routerLinkActive="text-trinidad"
                [routerLinkActiveOptions]="{ exact: false }"
                class="relative flex flex-col items-center justify-center gap-0.5 py-2.5 px-1 text-muted-text hover:text-dark-text transition-colors min-h-[44px]">
                <span aria-hidden="true" class="material-symbols-outlined text-[22px]" style="font-variation-settings: 'FILL' 0;">{{ slot.icon }}</span>
                <span class="text-[0.6rem] uppercase tracking-[0.1em] font-button font-bold leading-none">{{ slot.label }}</span>
                @if (slot.isMessages && unreadCount > 0) {
                  <span class="absolute top-1 right-1/2 translate-x-[14px] inline-flex items-center justify-center min-w-[1rem] h-4 px-1 rounded-full bg-trinidad text-white text-[0.55rem] font-button font-bold leading-none">
                    {{ unreadCount > 9 ? '9+' : unreadCount }}
                  </span>
                }
              </a>
            </li>
          }
        </ul>
      </nav>
    }
